// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"320":"86cd61c8","644":"063553a1","692":"0bb15e87","731":"4c4ba9cd","739":"6ddb620d","954":"6ddd99c3"}[chunkId] + ".chunk.js";
};